import store from '@sb/store'
var sb = require('@sb/util')

import PoweredBy from './PoweredBy.js'
import AgentsAvatar from './AgentsAvatar.js'
import Header from './Header.js'
var send = require('../../assets/img/send.svg')
import MessageInput from './MessageInput.js'
import Events from './Events.js'
import Typing from './Typing.js'
import QuickReplies from './QuickReplies.js'
const browser = require('bowser').getParser(window.navigator.userAgent).parsedResult
import Rating from './Rating.js'
import ListField from './ListField.js'

const defaultAvatar = 'https://filev4.subiz.com/fiqoahedjbgwclpouoml-avatar_default_baa8a1d7.png'

export default {
	name: 'widget',
	props: ['cid', 'view', 'isShow'],
	// view: chat, list

	data () {
		return {
			creating: false,
			clickedJoin: false,
			formData: {},
		}
	},

	mounted () {
		store.onUpdate(this, _ => this.$forceUpdate())
		store.onConvoEvent(this, ev => {
			if (!this.isShow) return
			if (sb.convoOfEv(ev) !== this.cid) return
			// if message if not from me => seen
			store.seenConvo(this.cid)
		})
		this.focusInput()
	},

	watch: {
		isShow (isShow) {
			if (isShow && !browser.platform.type === 'mobile') this.focusInput()
			if (isShow && browser.platform.type === 'mobile') this.blur()
		},
		cid (cid) {
			this.clickedJoin = false
			// store.setLastview('chat', { cid: this.cid })
			setTimeout(() => {
				// focus Events then focus MessageInput
				// if there is any pending form, MessageInput will be disabled
				// and dont steal focus from Events
				this.$refs.events && this.$refs.events.focus()
				this.focusInput()
			}, 100)
		},
	},

	render () {
		let $body = null
		let formRequired = this.isFormRequired()
		let showform = (formRequired && !this.cid) || (formRequired && this.cid && this.clickedJoin)

		let form
		// choose form to display
		let accountSetting = store.matchAccountSetting() || {}
		let submitLabel = this.$t('prechat_form_btn')
		if (sb.get(accountSetting, 'prechat_form.enabled')) form = accountSetting.prechat_form
		let offlineEnabled = sb.get(accountSetting, 'offline_form.enabled')
		if (!accountSetting.is_online && offlineEnabled) {
			form = accountSetting.offline_form
			submitLabel = this.$t('offline_form_btn')
		}

		if (this.view === 'list') $body = this.renderConvoList()
		else if (showform) $body = this.renderForm(form, submitLabel)
		else $body = this.renderChat()

		let position = sb.get(accountSetting, 'desktop_button.position') || 'right'
		if (browser.platform.type === 'mobile') position = sb.get(accountSetting, 'mobile_button.position', position)
		let cls = 'widget-container widget-container--' + position
		if (!this.isShow) cls += ' widget-container--hide'
		return (
			<div class={cls}>
				<Header
					cid={this.cid}
					view={this.view}
					vOn:close={() => this.$emit('close')}
					vOn:gotoList={() => this.$emit('go', { view: 'list' })}
				/>
				{$body}
			</div>
		)
	},

	methods: {
		async submitPrechatForm (form) {
			// check error first
			var hasError = false
			sb.map(this.formData, (field, key) => {
				if (
					field.is_required &&
					(field.value === undefined ||
						field.value === '' ||
						(sb.size(field.value) === 0 && Array.isArray(field.value)))
				) {
					field.error = this.$t('error_empty')
					hasError = true
				} else field.error = ''

				if (key.substr(5) === 'emails' && !sb.isEmail(field.value) && field.is_required) {
					field.error = this.$t('error_email_invalid') // 'The email is not valid'
					hasError = true
				}
			})

			if (hasError) return this.$forceUpdate()

			// user must already send the message or it would create be a loop
			let data = sb.cloneDeep(this.formData)
			// update user info based on form data
			let user = sb.cloneDeep(store.matchUser())
			sb.map(data, (field, key) => {
				if (!key.startsWith('attr:')) return
				var attr = { key: key.substr(5) }
				if (field.type === 'number') attr.number = parseInt(field.value)
				if (field.type === 'datetime') attr.datetime = new Date(field.value).toISOString()
				if (field.type === 'list') attr.list = field.value
				if (field.type === 'text' || field.type === 'boolean') attr[field.type] = field.value
				sb.setUserAttr(user, attr)
			})

			let firstmsg = sb.get(data, 'question.value')
			let groupid = sb.get(data, 'group.value', '')

			if (this.cid) {
				store.setUser(user)
				this.clickedJoin = false
				// form will auto disappear after rerender
				await store.sendConvoEvent(this.cid, 'message_sent', { message: { text: firstmsg, format: 'plaintext' } })

				// end_conversation_after_submit only for offline form or prechat form
				if (form.end_conversation_after_submit) await store.endConvo(this.cid)
				return
			}

			// creating convo
			this.creating = true
			let message = { text: firstmsg, format: 'plaintext' }
			let req = { group_id: groupid, message: firstmsg }

			this.creatingError = null
			const { error, convo } = await store.startConvo(req)
			store.setUser(user)
			if (error) {
				this.creating = false
				this.creatingError = error
				return
			}
			let newconvoid = convo.id
			this.$emit('go', { view: 'chat', cid: newconvoid })
			store.sendConvoEvent(newconvoid, 'message_sent', { message })
			this.creating = false
			this.clickedJoin = false
			this.focusInput()
		},

		formMounted (form) {
			// waiting for element to be created

			this.formData = fillForm(form)
			// focus on the element
			this.formData['question'] = {
				key: 'question',
				is_required: true,
				label: form.question_label || this.$t('your_question'),
				type: 'text',
			}

			let firstemptykey = ''
			sb.map(this.formData, (field, key) => {
				if (field.type !== 'text') return
				if (firstemptykey) return

				if (!field.value) firstemptykey = key
			})

			this.$nextTick(() => {
				var $input = this.$refs['form_' + encode(firstemptykey)]
				if (!$input) return
				$input.focus()
			}, 100)
		},

		renderFields () {
			if (sb.size(this.formData) === 0) return null

			let $fields = sb.map(this.formData, (field, key) => {
				let $field = null
				var errclass = field.error ? 'input--error' : ''
				if (field.type === 'text') {
					if (key === 'question') {
						$field = (
							<textarea
								class="form-control"
								ref={'form_' + encode(key)}
								vModel={field.value}
								row="4"
								class="form-control"></textarea>
						)
					} else {
						$field = (
							<input vModel={field.value} ref={'form_' + encode(key)} class={`form-control ${errclass}`} type="text" />
						)
					}
				} else if (field.type === 'number') {
					$field = <input vModel={field.value} class={`form-control ${errclass}`} type="number" />
				} else if (field.type === 'boolean') {
					$field = (
						<div class="checkbox">
							<input
								type="checkbox"
								id={'form-checkbox' + key}
								onChange={ev => (field.value = ev.target.checked)}
								checked={field.value}
							/>
							<label class="checkbox--label" for={'form-checkbox' + key}>
								{field.label}
							</label>
							<div class="checkbox--check">
								<div></div>
							</div>
						</div>
					)
				} else if (field.type === 'group') {
					$field = sb.map(field.list, item => (
						<div class="radio">
							<input type="radio" id={'form-radio' + key + item.value} vModel={field.value} value={item.value} />
							<label class="radio--label" for={'form-radio' + key + item.value} value={item.value}>
								{item.label}
							</label>
							<div class="radio--check">
								<div class="inside"></div>
							</div>
						</div>
					))
				} else if (field.type === 'list') {
					let selected = this.formData[key].value || []
					let items = sb.filter(sb.get(field, 'list', []), item => {
						return !sb.includes(selected, item)
					})
					$field = (
						<ListField
							selected={selected}
							items={items}
							vOn:onAddItem={item => {
								this.formData[key].value = this.formData[key].value || []
								this.formData[key].value.push(item)
							}}
							vOn:onRemoveItem={i => this.$delete(this.formData[key].value, i)}
						/>
					)
				} else if (field.type === 'datetime') {
					$field = <input vModel={field.value} class={`form-control ${errclass}`} type="date" />
				}

				let label = field.label
				if (field.key === 'fullname') {
					label = this.$t('fullname')
				} else if (field.key === 'emails') {
					label = this.$t('email')
				} else if (field.key === 'phones') {
					label = this.$t('phones')
				}

				return (
					<div>
						<div class="label">
							{label}
							{field.is_required ? <span class="ml-1 red">*</span> : ''}
						</div>
						{field.error ? <div class="form-control--valid-input--error">{field.error}</div> : ''}
						{$field}
					</div>
				)
			})
			return <div class="pt-2">{$fields}</div>
		},

		renderForm (form, submitLabel) {
			let $loading = null
			if (this.creating) $loading = <Spinner class="ml-2" size="16" mode="white" />

			return (
				<div class="widget-body">
					<FormMounter form={form} vOn:mounted={this.formMounted} />
					<div class="widget-body--content flex-grow-1 pl-3 pr-3 d-flex flex-column">
						<div class="flex-grow-1">
							<div class="form mt-3 pl-3 pr-3 pt-3 pb-3 d-flex flex-column">
								<div>{sb.get(form, 'title', this.$t('capture_lead_title'))}</div>
								{this.renderFields()}
							</div>
						</div>

						<PoweredBy />
					</div>

					<div class="message-input message-input--preform">
						<button class="btn--start-convo" vOn:click={_ => this.submitPrechatForm(form)}>
							{submitLabel} {$loading}
						</button>
					</div>
				</div>
			)
		},

		goToConvo (cid) {
			this.$emit('go', { view: 'chat', cid })
		},

		renderConvoList () {
			let convoM = store.matchConvo('*')
			var convos = sb.map(convoM, convo => store.matchConvo(convo.id))
			convos = sb.filter(convos, convo => !!convo)
			convos = sb.orderBy(convos, 'created', 'desc')

			var $convos = sb.map(convos, convo => {
				var agentids = sb.agentsOfConvo(convo)
				return (
					<div class="convo-list--item" vOn:click={() => this.goToConvo(convo.id)} key={convo.id}>
						<AgentsAvatar mode="member" class="d-flex flex-row" tooltipPos="right" agent_ids={agentids} />
						{this.renderConvoSummary(convo)}
					</div>
				)
			})
			let $body = <div class="convo-list--list">{$convos}</div>
			if (sb.size(convos) === 0) $body = <div class="convo-list--list">EMPTY</div>

			return (
				<div class="convo-list">
					<div class="convo-list--container">
						<div class="convo-list--title">{this.$t('conversations')}</div>
						{$body}
					</div>
					<div class="convo-list--footer">
						<button class="btn--start-convo" vOn:click={_ => this.goToConvo('')}>
							<span>{this.$t('start_conversation')}</span>
							<img src={send} alt />
						</button>
						<PoweredBy />
					</div>
				</div>
			)
		},

		blur () {
			if (store.isPreview) return
			var $input = this.$refs.msgInput
			if (!$input) return
			this.$nextTick(() => $input.blur())
			setTimeout(() => $input.blur(), 300) // force lose focus
		},

		focusInput () {
			if (store.isPreview) return
			var $input = this.$refs.msgInput
			if (!$input) return
			this.$nextTick(() => $input.focus())
			setTimeout(() => $input.focus(), 300) // force focus
		},

		onRate (rating) {
			if (!this.cid) return
			store.sendConvoEvent(this.cid, 'conversation_rated', { conversation: { ratings: [rating] } })
			this.focusInput()
		},

		async sendMessage (message) {
			let text = message.text
			if (!this.cid) {
				this.creating = true
				const { convo, error } = await store.startConvo({ message: text })
				if (error) {
					// show error and try again
				}
				this.creating = false
				store.sendConvoEvent(convo.id, 'message_sent', { message })

				this.$emit('go', { view: 'chat', cid: convo.id })

				return
			}
			store.sendConvoEvent(this.cid, 'message_sent', { message })
		},

		renderChat () {
			let $input = <MessageInput ref="msgInput" cid={this.cid} vOn:send={this.sendMessage} />
			let convo = store.matchConvo(this.cid) || {}
			if (this.isFormRequired() || convo.state === 'ended') {
				$input = (
					<div class="message-input message-input--preform">
						<button class="btn--start-convo" vOn:click={this.onStartConvoClick}>
							{this.$t('offline_preform_btn')}
						</button>
					</div>
				)
			}

			return (
				<div class="widget-body">
					<div class="widget-body--content" vOn:click={this.onContainerClick}>
						<Events vOn:formSubmit={this.onEventFormSubmit} ref="events" cid={this.cid} creating={this.creating} />
						<Typing cid={this.cid} />
						<QuickReplies cid={this.cid} vOn:select={this.chooseQuickReply} />
					</div>
					<Rating vOn:rate={this.onRate} cid={this.cid} />
					{$input}
				</div>
			)
		},

		// end or visit unsent convo which require form
		async onStartConvoClick () {
			var convo = store.matchConvo(this.cid) || {}
			if (convo.state === 'ended') return this.$emit('go', { view: 'chat', cid: '' })
			this.clickedJoin = true
		},

		onEventFormSubmit () {
			this.focusInput()
		},

		chooseQuickReply (value) {
			this.$refs.msgInput.submitMessage(value)
		},

		onContainerClick () {
			// ignore select behaviour
			var selection = window.getSelection()
			if (selection.toString().length > 0) return

			// focus text input on desktop
			if (browser.platform.type !== 'mobile') this.focusInput()
		},

		firstUnfilledField () {
			return sb.find(this.formData, field => field.value == null || field.value === '')
		},

		isFormRequired () {
			// neu isRequiredForm = true nhung form = null => show button khi click vao thi show form

			// isRequiredForm tra ve true neu (nguoi dung chua tung tra loi)
			//   + hoi thoai da dc phan phoi nhung chua nhap du cac truong (nho exclude group, bo qua ca truong message)
			//   + hoi thoai moi hoac chua duoc phan phoi va chua nhap du cac truong (dac biet la group). Neu k co group, ma cac truong da dc nhap du, ko quan tam toi da nhap msg hay chua, isrequiredform = false

			let form
			// choose form to display
			let accountSetting = store.matchAccountSetting() || {}
			if (sb.get(accountSetting, 'prechat_form.enabled')) form = accountSetting.prechat_form

			//auto detect form
			let offlineEnabled = sb.get(accountSetting, 'offline_form.enabled')
			if (!accountSetting.is_online && offlineEnabled) form = accountSetting.offline_form

			if (!form) return false

			let formData = fillForm(form)

			// dont care about group if the conversation is assigned
			let convo = store.matchConvo(this.cid) || {}

			if (convo.state === 'ended') return true
			if (userHasSent(this.cid)) return false
			if (convo.state && convo.state !== 'pending') delete formData.group
			return !!sb.find(formData, field => field.value == null || field.value === '')
		},

		renderConvoSummary (convo) {
			var agents = this.agentsOfConvo(convo)
			var name = sb.each(agents, ag => ag.fullname).join(', ')
			if (!name) name = store.matchAccount().name
			if (!name) name = this.$t('agent')

			var $you = null
			if (convo.lastSenderType === 'user') {
				$you = <span class="yourmessage">{this.$t('you')}:</span>
			}

			var time = new Date(sb.getMs(convo.last_actived) || sb.getMs(convo.created))
			var $tim = <Time ago={true} time={time} key={new Date().getTime()} />

			var lastmsg = this.renderMessagePreview({ data: { message: sb.get(convo, 'last_message') } })
			return (
				<div class="convo-list--convo-last-info">
					<div class="d-flex flex-row">
						<div class="convo-list--convo-name">{name}</div>
						<div class="convo-list--convo-time">{$tim}</div>
					</div>

					<div class="d-flex flex-row">
						<div class="convo-list--convo-last-message">
							{$you}
							{lastmsg}
						</div>
						{this.renderUnread(convo)}
					</div>
				</div>
			)
		},

		renderUnread (convo) {
			let events = store.listEvents(convo.id)
			let seen = sb.isConvoSeen(store.matchUser().id, events)
			if (seen) return null
			return <div class="convo-list--item-unread"></div>
		},

		agentsOfConvo (convo) {
			let agentM = store.matchAgent('*')
			var agentids = sb.agentsOfConvo(convo)
			return sb.map(agentids, id => agentM[id] || { avatar_url: defaultAvatar, fullname: 'Offline Agent' })
		},

		renderMessagePreview (ev) {
			let defmsg = this.$t('sent_you_a_message')

			let message = sb.get(ev, 'data.message.text')
			var format = sb.get(ev, 'data.message.format')

			// cant display message
			if (format !== 'plaintext') message = defmsg
			if (!message && sb.size(sb.get(ev, 'data.message.attachments')) > 0) message = defmsg

			if (!message) return null
			let byType = sb.get(ev, 'by.type')
			return sb.map(sb.extractText(message), tag => {
				if (tag.type === 'emoji') return <Emoji emojiCode={tag.text} byType={byType} />
				return tag.text
			})
		},
	},
}

function userHasSent (cid) {
	var convo = store.matchConvo(cid) || {}
	let user = store.matchUser()
	let joined = sb.find(convo.members, mem => mem.id === user.id && mem.membership === 'active')
	if (joined) return true

	var events = store.listEvents(cid) || {}

	let sent = sb.find(events, ev => sb.get(ev, 'by.id') === user.id && ev.type === 'message_sent')
	return sent
}

function fillForm (form) {
	if (sb.size(form) === 0) return []
	// this.selectedGroupId = ''
	// init data
	var data = {}
	let user = store.matchUser()
	sb.each(form.fields, f => {
		var newf = Object.assign({}, f)
		// fill in user attribute
		newf.value = sb.getUserAttr(user, f.key, f.type)

		if (f.type === 'boolean' && !newf.value) newf.value = false
		if (f.type === 'datetime' && newf.value) {
			// time picker only show if we pass time in this format yyyy-MM-dd
			newf.value = new Date(data.value).toLocaleDateString('en-CA')
		}

		if (f.type === 'list') {
			newf.list = f.list
		}
		data['attr:' + f.key] = newf
	})

	if (form.group_required && sb.size(form.groups) > 0) {
		data['group'] = {
			key: 'group',
			is_required: !!form.group_required,
			label: form.group_label,
			type: 'group',
			list: sb.map(form.groups, group => ({ value: group.id, label: group.name })),
		}
	}
	return data
}

let FormMounter = {
	name: 'FormMounter',
	props: ['form'],
	mounted () {
		this.$emit('mounted', this.form)
	},
	render () {
		return null
	},
}

function encode (key) {
	return btoa(key).
		split('=').
		join('')
}
